module.exports = __webpack_public_path__ + "media/images/ribbon-16e26d7ffaabdce3b3ad795a95000a6c.png";